export const updateLoading = (show) => {
    return {
        type:'UPDATE_LOADING',
        loading:{show}
    }
}